
//현재 URL에 해당하는 메뉴를 ACTIVE합니다.
export function activeMenu(url) {
    return { type: 'ACTIVE_MENU', url: url };
}

  